import { CONVERSATION_TEXTS } from '../../conversation/texts';

/** User-facing copy of the log's stages rail. */
export const STAGES_RAIL_TEXTS = {
  /** What the rail is, to a screen reader. */
  LABEL: 'Stage changes',
  /** A chapter's detail for the stage the claim was opened in. */
  CLAIM_OPENED: 'Claim opened',
  /** A chapter's detail: the stage the claim came from. */
  FROM: (stageLabel: string): string => `from ${stageLabel}`,
  /** A chapter's detail, with the person who moved the claim: "from Coverage · Jane Doe". */
  BY: (detail: string, name: string): string => `${detail}${CONVERSATION_TEXTS.SEPARATOR}${name}`,
};
